export default {
      id: "reefer-temperature-usage",
      viewBox: "0 0 26 36",
      url: __webpack_public_path__ + "img/icons.svg#reefer-temperature",
      toString: function () {
        return this.url;
      }
    }